import { render, staticRenderFns } from "./LungMedicalDetails.vue?vue&type=template&id=05182397"
import script from "./LungMedicalDetails.vue?vue&type=script&lang=js"
export * from "./LungMedicalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports